import { GeneralDetailsSchema, MoreInformationSchema, SourceSchema } from "./schema";
import { DueDiligenceDetails, DueDiligenceFormStage, FiscalResidenceChanged } from "./types";

export const RiskCategory = {
    Low: 1,
    Moderate: 2,
    High: 3
} as const;

export const DueDiligenceStatus = {
  OverDue: 0,
  InProgress: 1,
  Completed: 2,
  NoProgress: 3,
  Verified: 4
} as const;

export const RiskOptions = [
  'All',
  'Risk Category 1',
  'Risk Category 2',
  'Risk Category 3',
] as const;

export const PlannedInvestmentVolume = {
    Range0To24999: 43,
    Range25000To49999: 44,
    Range50000To99999: 45,
    Range100000To149999: 46,
    Range150000OrMore: 47
} as const;

export const PlannedInvestmentVolumeOptions = [
    { text: '0 - 24,999 EUR', value: PlannedInvestmentVolume.Range0To24999 },
    { text: '25,000 - 49,999 EUR', value: PlannedInvestmentVolume.Range25000To49999 },
    { text: '50,000 - 99,999 EUR', value: PlannedInvestmentVolume.Range50000To99999 },
    { text: '100,000 - 149,999 EUR', value: PlannedInvestmentVolume.Range100000To149999 },
    { text: '150,000 EUR or more', value: PlannedInvestmentVolume.Range150000OrMore }
] as const;

export const PlannedInvestmentFrequency = {
  OneOff: 0,
  Regular: 1,
  Others: 2,
} as const;

export const PlannedInvestmentFrequencyOptions = [
  { text: 'One-off', value: PlannedInvestmentFrequency.OneOff },
  { text: 'Regular', value: PlannedInvestmentFrequency.Regular },
  { text: 'Others', value: PlannedInvestmentFrequency.Others },
] as const;

export const DueDiligenceFormStages = {
    GeneralDetails: 1,
    SourceOfWealth: 2,
    SourceOfFunds: 3,
    MoreInformation: 4
} as const;

export const DueDiligenceStageOrder: readonly DueDiligenceFormStage[] = [
    DueDiligenceFormStages.GeneralDetails,
    DueDiligenceFormStages.SourceOfWealth,
    DueDiligenceFormStages.SourceOfFunds,
    DueDiligenceFormStages.MoreInformation
];

export const StageToSchema = {
  [DueDiligenceFormStages.GeneralDetails]: (fiscalResidenceChanged: FiscalResidenceChanged) =>
    GeneralDetailsSchema(fiscalResidenceChanged),
  [DueDiligenceFormStages.SourceOfWealth]: () => SourceSchema,
  [DueDiligenceFormStages.SourceOfFunds]: () => SourceSchema,
  [DueDiligenceFormStages.MoreInformation]: () => MoreInformationSchema,
 } as const;

export const StageToKey = {
    [DueDiligenceFormStages.GeneralDetails]: 'GeneralDetails',
    [DueDiligenceFormStages.SourceOfWealth]: 'SourceOfWealth',
    [DueDiligenceFormStages.SourceOfFunds]: 'SourceOfFunds',
    [DueDiligenceFormStages.MoreInformation]: 'MoreInformation',
} as const;

export const SourceTypes = {
    Wealth: 'wealth',
    Funds: 'funds'
} as const;

export const InitialDetailsState = {
  GeneralDetails: {
    PlatformAccount: {
      AccountNumber: '',
      ConsultantEmail: null,
      ConsultantName: null,
      PlatformAccountType: null,
    },
    PrimaryAccountHolder: {
      Name: {
        FirstName: '',
        LastName: '',
      },
      ContactDetails: {
        EmailAddress: null,
        MobileNo: null,
      },
      Address: {
        Street: null,
        StreetNo: null,
        PostalCode: null,
        Place: null,
        Country: null,
      },
      PersonalInfo: {
        BirthDate: null,
        PlaceOfBirth: null,
        CountryOfBirth: null,
        Nationality: null,
      },
      TaxInfo: {
        CountryOfFiscalResidence: null,
        TinNo: null,
        ReasonNoTinNumber: null,
        IsUSTaxResident: null,
        IsPolExposed: null,
      },
      EmploymentDetails: null,
    },
    SecondaryAccountHolder: null,
    PlannedInvestmentDetails: {
      PlannedInvestmentVolume: null,
      PlannedInvestmentFrequency: null,
      PlannedInvestmentFrequencyOther: null,
    },
  },
  SourceOfWealth: [],
  SourceOfFunds: [],
  MoreInformation: null,
  EmailType: null,
  ConsultantBostonId: null,
  ClientBostonId: null,
} as DueDiligenceDetails;

export const ReminderSkipLimit = 15 as const;